// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xnaO","col":"styles_col__1q0HL"};